import * as React from 'react';
import { WithChildrenCommonProps } from '@types';
import { twMerge } from 'tailwind-merge';

export type FieldContentProps = WithChildrenCommonProps<unknown>;

export const FieldContent = React.forwardRef(
  (
    props: FieldContentProps,
    ref: React.ForwardedRef<HTMLDivElement>
  ): JSX.Element => {
    const { children, className: classNameProp, ...rest } = props;

    const twClassName = twMerge('relative w-full grow', classNameProp);

    return (
      <div ref={ref} className={twClassName} {...rest}>
        {children}
      </div>
    );
  }
);

FieldContent.displayName = 'FieldContent';
